import { ItemGroupSummary } from "../component";
/**
 * This function is a helper for the order tracker. It checks if either the tracker has a single (normal)
 * non-pillpack order and returns the first item and its associated orderKeyId. If such an order doesn't exist (only pillpack shipment),
 * then we search for the pillpack group summaries. If the showShiplit is turned on it will return the associated orderKeyId.
 * If undefined is returned, we know we cannot show shiplit.
 *
 * @param itemGroupSummary passed in via the calling function (prop to tracker page)
 * @returns undefined or orderKeyId
 */
function findOrderKeyIdAndCheckShiplitStatus (itemGroupSummary: ItemGroupSummary): string | undefined {
    // Check if itemGroupSummary is null or undefined
    if (!itemGroupSummary) {
        return undefined;
    }

    // Check normal case: regular itemGroups
    if (itemGroupSummary.itemGroups &&
        itemGroupSummary.itemGroups.length > 0 &&
        itemGroupSummary.itemGroups[0] &&
        itemGroupSummary.itemGroups[0].itemSummaries &&
        itemGroupSummary.itemGroups[0].itemSummaries.length > 0 &&
        itemGroupSummary.itemGroups[0].itemSummaries[0] &&
        itemGroupSummary.itemGroups[0].itemSummaries[0].showShiplit) {

        return itemGroupSummary.itemGroups[0].itemSummaries[0].id;
    }

    // Check pillpack group summaries
    if (itemGroupSummary.pillPackGroupSummary &&
        itemGroupSummary.pillPackGroupSummary.itemGroups &&
        itemGroupSummary.pillPackGroupSummary.itemGroups.length > 0 &&
        itemGroupSummary.pillPackGroupSummary.itemGroups[0] &&
        itemGroupSummary.pillPackGroupSummary.itemGroups[0].itemSummaries &&
        itemGroupSummary.pillPackGroupSummary.itemGroups[0].itemSummaries.length > 0 &&
        itemGroupSummary.pillPackGroupSummary.itemGroups[0].itemSummaries[0] &&
        itemGroupSummary.pillPackGroupSummary.itemGroups[0].itemSummaries[0].showShiplit) {

        return itemGroupSummary.pillPackGroupSummary.itemGroups[0].itemSummaries[0].id;
    }

    // Check bottle group summaries
    if (itemGroupSummary.bottleGroupSummary &&
        itemGroupSummary.bottleGroupSummary.itemGroups &&
        itemGroupSummary.bottleGroupSummary.itemGroups.length > 0 &&
        itemGroupSummary.bottleGroupSummary.itemGroups[0] &&
        itemGroupSummary.bottleGroupSummary.itemGroups[0].itemSummaries &&
        itemGroupSummary.bottleGroupSummary.itemGroups[0].itemSummaries.length > 0 &&
        itemGroupSummary.bottleGroupSummary.itemGroups[0].itemSummaries[0] &&
        itemGroupSummary.bottleGroupSummary.itemGroups[0].itemSummaries[0].showShiplit) {

        return itemGroupSummary.bottleGroupSummary.itemGroups[0].itemSummaries[0].id;
    }

    return undefined;
}

export default findOrderKeyIdAndCheckShiplitStatus;